import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { RelatorioRequest } from '../../requests/scanntech/relatorio.request';

@Injectable({
  providedIn: 'root',
})
export class RelatorioService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public gerarRelatorio(relatorioRequest: RelatorioRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(environment.urlApiScanntech + 'Relatorio', relatorioRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
